import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TeacherTable from "./Component/TeacherTable"


const Teacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TeacherTable />
            
        </div>
        <Footer />
        </>
    )
}

export default Teacher